import { CreateProjectSteps } from './create-project-steps';
import { Collection } from 'views/store/common/utility/adt/collection';
import dustjs from 'dustjs';

import _ProjectChecklistsCreateModalDust from 'store/global/common/projects/roomchecklists/_create_modal.dust';
import { ProjectChecklistsModel } from 'models/store/client/projects/roomchecklists/project_checklists';

export class ProjectChecklistsCreateModal extends CreateProjectSteps {
	static events = {
		show: 'view:projects:checklists:modal:show',
		hide: 'view:projects:checklists:modal:hide',
		groupsCreated: 'view:projects:checklists:modal:groupsCreated',
		afterRender: 'view:projects:checklists:modal:afterAfter'
	};

	events() {
		return super.events();
	}

	preinitialize(options) {
		super.preinitialize(options);
		if (!this.el) {
			this.el = '.js-modal-new-room-checklists';
		}
	}

	initialize(options = {}) {
		super.initialize(options);
		this.attachEvents();
	}

	attachEvents() {
		this.$el.on('hide.bs.modal', this.onModalHidden.bind(this));
		this.listenTo(this.model.get('checklists'), Collection.events.updated, this.onSelectionChange);
		this.listenTo(this.model.get('paginated'), Collection.events.replacedAll, this.update);
		this.listenTo(this.model, 'change:step', this.onStepChange);
		return this;
	}

	render() {
		super.render();
		dustjs.render(
			_ProjectChecklistsCreateModalDust,
			{
				projectsRoomChecklists: this.model.toJSON(),
				objectToCreate: this.projectId ? 'group' : 'project'
			},
			this.afterRender.bind(this)
		);
		return this;
	}

	afterRender(err, out) {
		if (err) {
			window.clientErrorHandler(err);
		}
		this.$el.find('.modal-body').html(out);
		this.cache().update();
		return this.trigger(ProjectChecklistsCreateModal.events.afterRender, this);
	}

	onModalHidden() {
		this.model.clearSelection();
		return this.trigger(ProjectChecklistsCreateModal.events.hide, this);
	}

	show() {
		this.$el.modal('show');
		return this.trigger(ProjectChecklistsCreateModal.events.show);
	}

	hide() {
		this.$el.modal('hide');
		return this;
	}

	onStepChange() {
		const current = this.model.get('step');
		if (current === ProjectChecklistsModel.steps.step1) {
			this.changeToStep(ProjectChecklistsModel.steps.step1);
		} else if (current === ProjectChecklistsModel.steps.step2) {
			if (this.projectId) {
				this.createGroupsForProject();
				this.hide();
			} else {
				this.changeToStep(ProjectChecklistsModel.steps.step2);
				this.$projectNameInput.focus();
			}
		}
		return this;
	}

	createGroupsForProject() {
		this.model.createGroupsForProject((model, response) =>
			this.reset().trigger(ProjectChecklistsCreateModal.events.groupsCreated, response)
		);
	}
}
